import type { DeliveryResultScreenModel } from './DeliveryResultScreenModelScreen';

export class DeliveryResultScreenController {
  constructor(private readonly model: DeliveryResultScreenModel) {}

  handleRestart = () => {
    if (!this.model.canRestart) {
      return;
    }
    this.model.onRestart?.();
  };

  handleGoHome = () => {
    this.model.onGoHome?.();
  };
}
